export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gradient-to-br from-background-200 via-background-200 to-primary-950/20 border border-background-300/40 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
              <i className="ri-smartphone-line text-accent-400 text-sm"></i>
              <span className="text-xs text-accent-400 font-medium whitespace-nowrap">移动端专属</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              暗网吃瓜客户端
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mb-6">
              随时随地掌握最新爆料动态。暗网吃瓜客户端支持离线缓存、
              推送提醒与夜间模式，让你不错过任何一条重磅黑料。
              支持 iOS 与 Android 双平台，扫码或点击下方按钮下载。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                className="px-6 py-3 bg-background-100 border border-background-300/50 hover:border-accent-500/50 rounded-lg transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 text-sm text-foreground-700"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a
                href="#app"
                className="px-6 py-3 bg-background-100 border border-background-300/50 hover:border-accent-500/50 rounded-lg transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 text-sm text-foreground-700"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 bg-background-100 border border-background-300/40 rounded-2xl flex items-center justify-center">
              <div className="text-center">
                <i className="ri-qr-code-line text-5xl text-accent-400"></i>
                <p className="text-xs text-foreground-500 mt-3">扫码下载客户端</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}